export const isPromise = <T = any>(value: any): value is Promise<T> => typeof value?.then === 'function'
